import { Col, Form, Row } from 'reactstrap';
import { OutlinedSelect, Button, TextOutlinedInput } from '@octano/global-ui';
import { StudentsRiskHistoryLoader } from './hooks/StudentsRiskHistoryLoader';
import { useCallback } from 'react';
import { useTexts } from './hooks/useTexts';
import { StudentRiskPrimaryFiltersLoaderData } from './hooks/StudentRiskFiltersLoader';
import { StudentsRiskHistoryFiltersParams } from './types';
import { useForm } from 'react-hook-form';

export const SecondaryFilters = () => {
  const { secondaryFilters } = StudentRiskPrimaryFiltersLoaderData();

  const {
    riskSessionsOptions,
    campusesOptions,
    studyPlansOptions,
  } = secondaryFilters;
  const texts = useTexts();
  const secondaryFiltersTexts = texts.secondaryFilter;
  const buttonsTexts = texts.buttons;
  const { query, updateQuery } = StudentsRiskHistoryLoader();
  const secondaryFiltersDefaultValues = {
    startAt: null,
    endAt: null,
    nameOrId: null,
    session: null,
    studyPlan: null,
    campus: null,
    promotion: null,
    course: null,
  };

  const {
    handleSubmit,
    reset,
    control,
  } = useForm<StudentsRiskHistoryFiltersParams>({
    defaultValues: secondaryFiltersDefaultValues,
  });

  const handleSearch = useCallback(
    (filters: StudentsRiskHistoryFiltersParams) => {
      updateQuery({
        ...query,
        page: 0,
        initialDate: filters?.startAt || undefined,
        endDate: filters?.endAt || undefined,
        nameOrId: filters?.nameOrId || undefined,

        studyPlanId: filters?.studyPlan?.value || undefined,
        sessionId: filters?.session?.value || undefined,
        campusId: filters?.campus?.value || undefined,
        promotion: filters?.promotion?.value || undefined,
        course: filters?.course?.value || undefined,
      });
    },
    [updateQuery, query],
  );

  return (
    <Form onSubmit={handleSubmit(handleSearch)}>
      <Row className="d-flex justify-content-between align-items-center mt-4">
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <TextOutlinedInput
            type={'date' as any}
            name="startAt"
            control={control}
            label={secondaryFiltersTexts.initialDate}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <TextOutlinedInput
            type={'date' as any}
            name="endAt"
            control={control}
            label={secondaryFiltersTexts.endDate}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <TextOutlinedInput
            label={secondaryFiltersTexts.nameOrId}
            placeholder={secondaryFiltersTexts.placeholders.nameOrId}
            name="nameOrId"
            control={control}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <OutlinedSelect
            label={secondaryFiltersTexts.session}
            placeholder={secondaryFiltersTexts.placeholders.session}
            name="session"
            control={control}
            options={riskSessionsOptions}
            isClearable={true}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <OutlinedSelect
            label={secondaryFiltersTexts.studyPlan}
            placeholder={secondaryFiltersTexts.placeholders.studyPlan}
            name="studyPlan"
            control={control}
            options={studyPlansOptions}
            isClearable={true}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <OutlinedSelect
            label={secondaryFiltersTexts.campus}
            placeholder={secondaryFiltersTexts.placeholders.campus}
            name="campus"
            control={control}
            options={campusesOptions}
            isClearable={true}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <OutlinedSelect
            label={secondaryFiltersTexts.promotion}
            placeholder={secondaryFiltersTexts.placeholders.promotion}
            name="promotion"
            // control={control} TODO agregar se tenga promotions
            options={[]}
            disabled
          />
        </Col>
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <OutlinedSelect
            label={secondaryFiltersTexts.course}
            placeholder={secondaryFiltersTexts.placeholders.course}
            name="course"
            // control={control} TODO agregar se tenga promotions
            options={[]}
            disabled
          />
        </Col>
      </Row>
      <div className="d-flex justify-content-end mt-2 mb-4">
        <Button
          className="mr-3"
          text={buttonsTexts.search}
          size="md"
          type="submit"
        />
        <Button
          outlined
          type="submit"
          text={buttonsTexts.clear}
          size="md"
          onClick={() => {
            reset(secondaryFiltersDefaultValues);
            updateQuery({
              ...query,
              page: 0,
              initialDate: undefined,
              endDate: undefined,
              nameOrId: undefined,
              sessionId: undefined,
              studyPlanId: undefined,
              campusId: undefined,
              promotion: undefined,
              course: undefined,
            });
          }}
        />
      </div>
    </Form>
  );
};
